import type { IconSvgObject } from './types';

const BalloonIcon: IconSvgObject = [
  ["path", { d: "M12.5 17C14.5 17 18.5 12.5 18.5 8C18.5 4.68629 15.8137 2 12.5 2C9.18629 2 6.5 4.68629 6.5 8C6.5 12.5 10.5 17 12.5 17Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.5 8C14.5 6.89543 13.6046 6 12.5 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12.5 17V18C12.5 19.1046 11.6046 20 10.5 20H7.5C6.39543 20 5.5 20.8954 5.5 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default BalloonIcon;
